import React, { useMemo } from "react";
import cn from "classnames";
import { AirSearchCardModel } from "entities/AirSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";
import { Airline } from "./Airline";
import styles from "./AirlineList.module.scss";

type AirlineListProps = {
  className?: string;
  data: Nullable<AirSearchCardModel>;
};

export const AirlineList: React.FC<AirlineListProps> = ({ data, className }) => {
  const airlines = useMemo(() => data?.airlines ?? [], [data?.rawData]);
  const hasAirlines = airlines.length > 0;

  return (
    <div className={cn(styles["vessel-list"], !hasAirlines && styles["not-available"], className)}>
      {hasAirlines ? (
        airlines.map((airline, index) => <Airline key={index} airline={airline} />)
      ) : (
        <>
          <div className={styles["not-available-bold"]}>{t("Flight details are not available at the moment")}</div>
          <div className={styles["not-available-normal"]}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
